export default {
    install(Vue: any) {
        Vue.mixin({
            computed: {
                $isMondrian() {
                    return true
                },
            },
        })
    },
}
